import React, { Component } from 'react'
import { withRouter } from 'react-router-dom'
import CacheKeys from '../../cache/CacheKeys'
import CacheManager from '../../cache/CacheManager'
import RestApiUtils from '../../apiclient/moebli/RestApiUtils'
import AlertListPageUI from './AlertListPageUI.js'
import LocalStorageKeys from '../../cache/LocalStorageKeys'

class AlertListPageSF extends Component {
  constructor(props) {
    super(props)
    this.state = {
      messageList: null,
      errorList: null,
      alertList: null,
      filteredAlertList: null,
      updateDueDateMode: false,
      sendReminderMode: false,
      allocateMode: false,
      searchFilter: ''
    }
  }

  render() {
    return (
      <AlertListPageUI
        context={this.props.context}
        messageList={this.state.messageList}
        errorList={this.state.errorList}
        alertList={this.state.alertList}
        filteredAlertList={this.state.filteredAlertList}
        searchFilter={this.state.searchFilter}
        // events
        onRefreshClick={this.onRefreshClick}
        onDismissClick={this.onDismissClick}
        onSearchFilterChange={this.onSearchFilterChange}
        // update due date modal
        updateDueDateMode={this.state.updateDueDateMode}
        onUpdateDueDateClick={(event) => { this.setState({updateDueDateMode: true}) }}
        onCancelUpdateDueDate={(event) => { this.setState({updateDueDateMode: false}) }}
        onUpdateDueDateComplete={this.onUpdateDueDateComplete}
        // send reminder modal
        sendReminderMode={this.state.sendReminderMode}
        onSendReminderClick={(event) => { this.setState({sendReminderMode: true}) }}
        onCancelSendReminder={(event) => { this.setState({sendReminderMode: false}) }}
        onSendReminderComplete={this.onSendReminderComplete}
        // allocate funds modal
        allocateMode={this.state.allocateMode}
        onAllocateClick={(event) => { this.setState({allocateMode: true}) }}
        onCancelAllocate={(event) => { this.setState({allocateMode: false}) }}
        onAllocateComplete={this.onAllocateComplete}
      />
    )
  }

  componentDidMount() {
    let context = this.props.context
    this.getAlerts(context)
    this.getMessages(context)
  }

  getAlerts(context) {
    if (!context.permissions) { // session expired for some reason
      localStorage.removeItem(LocalStorageKeys.Session)
      localStorage.removeItem(LocalStorageKeys.Session + ':CachedTime')
      setTimeout(() => {
        window.location = '/pub/message?key=invalid_session'
      }, 10)
      return
    }

    let cacheManager = new CacheManager({
      resource: `/api/accounts/${context.session.accountId}/alerts`,
      cacheKey: CacheKeys.Alerts(context.session.accountId),
      callback: this.getAlertsCallback,
      ttlInSecs: 600
    })
    cacheManager.getObject2(context)
  }

  getAlertsCallback = (response) => {
    let filtersStr = sessionStorage.getItem(CacheKeys.AlertsFilter(this.props.context.session.accountId))
    let filters = filtersStr ? JSON.parse(filtersStr) : {}

    this.setState({
      errorList: response.errorList,
      alertList: response.alertList,
      searchFilter: filters.searchFilter ? filters.searchFilter : '',
    })

    this.applyFilters(response.alertList, filters.searchFilter ? filters.searchFilter : '')
  }

  applyFilters(alertList, searchFilter) {
    let filteredList = alertList

    if (searchFilter)
      filteredList = filteredList.filter(alert =>
        alert.message.toLocaleLowerCase().includes(searchFilter.toLocaleLowerCase())
      )

    this.setState({ filteredAlertList: filteredList })

    let filters = {
      searchFilter: searchFilter,
    }
    sessionStorage.setItem(CacheKeys.AlertsFilter(this.props.context.session.accountId), JSON.stringify(filters))
  }

  onRefreshClick = () => {
    let context = this.props.context
    CacheManager.removeObject(CacheKeys.Alerts(context.session.accountId))
    this.setState({
      errorList: null,
      alertList: null,
      filteredAlertList: null
    }, () => {
      this.getAlerts(context)
    })
  }

  onDismissClick = (event) => {
    let context = this.props.context
    // console.log("Hello", event.currentTarget.getAttribute('data-id'))

    RestApiUtils.delete(context,
      `/api/alerts/${event.currentTarget.getAttribute('data-id')}`,
      this.onDismissClickCallback);
  }

  onDismissClickCallback = (response) => {
    let alertList = this.state.alertList.filter(alert => alert.alertId !== response.alert.alertId)
    let filteredAlertList = this.state.filteredAlertList.filter(alert => alert.alertId !== response.alert.alertId)

    // console.log("Hello", alertList)
    CacheManager.removeObject(CacheKeys.Alerts(response.alert.accountId))

    this.setState({
      errorList: response.errorList,
      alertList: alertList,
      filteredAlertList: filteredAlertList
    })
  }

  onSearchFilterChange = (event) => {
    let searchFilter = event.target.value
    this.setState({ searchFilter: searchFilter })
    this.applyFilters(this.state.alertList, searchFilter)
  }

  onUpdateDueDateComplete = () => {
    // let context = this.props.context
    // CacheManager.removeObject(CacheKeys.OrderInvoices(invoice.customerOrderId))
    // this.setState({ invoice: invoice })
    // setTimeout(() => {
    //   this.setState({ createInvoiceMode: false })
    //   this.props.history.push(`/invoices/${invoice.customerInvoiceId}`)
    // }, 2000)
  }

  onSendReminderComplete = () => {
    // let context = this.props.context
    // CacheManager.removeObject(CacheKeys.OrderInvoices(invoice.customerOrderId))
    // this.setState({ invoice: invoice })
    // setTimeout(() => {
    //   this.setState({ createInvoiceMode: false })
    //   this.props.history.push(`/invoices/${invoice.customerInvoiceId}`)
    // }, 2000)
  }

  onAllocateComplete = () => {
    // let context = this.props.context
    // CacheManager.removeObject(CacheKeys.OrderInvoices(invoice.customerOrderId))
    // this.setState({ invoice: invoice })
    // setTimeout(() => {
    //   this.setState({ createInvoiceMode: false })
    //   this.props.history.push(`/invoices/${invoice.customerInvoiceId}`)
    // }, 2000)
  }

  getMessages(context) {
    let arr = [
      'c_refresh',
      'c_alerts',
      'c_dismiss',
      'c_no_alert_msg',
      'c_change_due_date',
      'c_send_reminder',
      'c_provide_details',
      'c_allocate',
      'c_review'
    ]
    let keys = arr.join(',')

    let cacheManager = new CacheManager({
      resource: `/api/pub/messages/${keys}/locale/${context.locale}`,
      cacheKey: CacheKeys.Messages('pg_alerts', context.locale),
      callback: this.getMessagesCallback,
      ttlInSecs: 3600
    })
    cacheManager.getObject2(context)
  }

  getMessagesCallback = (response) => {
    this.setState({ messageList: response.messageList })
  }
}

export default withRouter(AlertListPageSF)
